"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetStatus = void 0;
var react_1 = require("react");
var ui_components_1 = require("@l2p/ui-components");
var useGetStatus = function () {
    return (0, react_1.useCallback)(function (status) {
        return status === 'active' || status === 'ACTIVE'
            ? ui_components_1.StatusType.success
            : ui_components_1.StatusType.error;
    }, []);
};
exports.useGetStatus = useGetStatus;
